import React, { useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { FAQ_COLLECTION, serverTimestamp } from '../../firebase'
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from 'react-router';

const INITIAL_STATE = {
    _id: '',
    date: serverTimestamp.now(),
    description_en: '',
    description_sr: '',
    title_en: '',
    title_sr: ''
}

const AddFaq = () => {

    const history = useHistory();

    const [add, setAdd] = useState(INITIAL_STATE)

    const handleAdd = async (e) => {

        e.preventDefault();

        const _id = uuidv4();

        await FAQ_COLLECTION.doc(_id).set({
            _id: _id,
            date: add.date,
            description_en: add.description_en,
            description_sr: add.description_sr,
            title_en: add.title_en,
            title_sr: add.title_sr
        })
            .then(() => {
                alert("Uspješno dodano 👍")
                history.push('/preview-faq')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <div>
                <Container>
                    <Tabs defaultActiveKey="add-faq" className="mb-3" transition={false}>
                        <Tab eventKey="preview-faq" title={<div onClick={() => history.push('/preview-faq')}>Pregled faq</div>} />
                        <Tab eventKey="add-faq" title="Dodaj">
                            <Form onSubmit={handleAdd}>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Opis (EN)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Opis (EN)"
                                                value={add.description_en}
                                                onChange={(e) => { setAdd({ ...add, description_en: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Opis (SR)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Opis (SR)"
                                                value={add.description_sr}
                                                onChange={(e) => { setAdd({ ...add, description_sr: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naslov (EN)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Naslov (EN)"
                                                value={add.title_en}
                                                onChange={(e) => { setAdd({ ...add, title_en: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naslov (SR)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Naslov (SR)"
                                                value={add.title_sr}
                                                onChange={(e) => { setAdd({ ...add, title_sr: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Button variant="primary" type="submit">
                                            Dodaj
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Tab>
                        <Tab eventKey="edit-faq" title='Uredi' disabled />
                        <Tab eventKey="delete-faq" title='Obriši' disabled />
                    </Tabs>
                </Container>
            </div>
        </>
    )
}

export default AddFaq
